import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AppRouter from '@/router/index';
import Store from '@/store';



ReactDOM.render(
  <Provider store={Store}>
    <AppRouter></AppRouter>
  </Provider>
  , document.getElementById('root'));